<script>
	export default {
		components: {
			'apple-icon': require('components/svg/apple-icon.vue').default,
			'lightning-icon': require('components/svg/lightning-icon.vue').default
		},
		props: {
			article: {
				required: true,
				type: Object
			},
			selectedArticle: {
				type: Object
			},
			articleList: {
				type: Array
			},
			showChallenge: {
				default: true
			},
			showSupport: {
				default: true
			},
			stepRead: {
				default: null
			},
			decodables: {
				type: Boolean,
				default: false
			},
			annotations: {
				type: Object
			}
		},
		computed: {
			supplementalArticles() {
				const article = this.article;
				const supplementalTexts = article.supplemental_texts;
				const showSupport = this.showSupport;
				const showChallenge = this.showChallenge;
				let supplementalArticles = [];

				if (!(supplementalTexts && (showSupport || showChallenge))) {
					return supplementalArticles;
				}

				if (showSupport) {
					const supportArticles = {
						articles: supplementalTexts.support,
						class: 'support',
						icon: 'apple-icon',
						subTitle: 'Boost Article'
					};

					supplementalArticles.push(supportArticles);
				}

				if (showChallenge) {
					const challengeArticles = {
						articles: supplementalTexts.challenge,
						class: 'challenge',
						icon: 'lightning-icon',
						subTitle: 'Challenge Article'
					};

					supplementalArticles.push(challengeArticles);
				}

				return supplementalArticles;
			}
		},
		methods: {
			onArticleSelect(uuid) {
				this.$emit('article-selected', uuid);
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'mixins/media';

	.article-selection {
		.article-selection-nav {
			background-color: $c-blue-lighter;
			margin: 1rem 0.5rem 0rem 0rem;

			&.supplemental {
				.article-selection-nav-list {
					gap: 0.25rem 1.875rem;
				}

				a {
					display: flex;
				}
			}
		}

		.article-selection-nav-list {
			display: grid;
			grid-template-columns: repeat(2, 1fr);
			gap: 0 1.875rem;
			padding: 0 0.9375rem;

			@include media(sm, max) {
				grid-template-columns: 1fr;
			}

			&.three-columns {
				@include media(med) {
					grid-template-columns: repeat(3, 1fr);
				}
			}
		}

		.article-title {
			color: $c-slate-dark;
			font-weight: 500;
			margin-right: 0;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;

			&.active {
				color: $c-blue;

				.sub-title {
					color: $c-slate-dark;
				}
			}
		}

		svg {
			flex-shrink: 0;
			margin: 0.5rem;
			stroke: currentColor;
		}

		.title-container {
			min-width: 0;
		}

		.sub-title {
			font-size: 0.75rem;
			color: $c-slate-dark;
		}
	}
</style>
<template>
	<div class="article-selection">
		<nav class="article-selection-nav row">
			<ul
				class="article-selection-nav-list list-unstyled"
				:class="{ 'three-columns': decodables }">
				<li
					v-for="(subArticle, index) in articleList"
					:key="subArticle.uuid"
					class="text-ellipsis article-meta">
					<a
						class="article-title"
						:class="{
							active: selectedArticle.uuid === subArticle.uuid
						}"
						:title="subArticle.title"
						@click="onArticleSelect(subArticle.uuid)">
						<template v-if="stepRead">StepRead{{ subArticle.order }}</template>
						<template v-else>
							{{ subArticle.title + (subArticle.subType === 103 ? ' (Video)' : '') }}
						</template>
						<template v-if="annotations?.[subArticle.uuid]"> (Highlighted) </template>
					</a>
				</li>
			</ul>
		</nav>
		<nav
			v-if="supplementalArticles.length > 0"
			class="article-selection-nav supplemental">
			<ul class="article-selection-nav-list list-unstyled">
				<template v-for="supplementalGroup in supplementalArticles">
					<li
						v-for="subArticle in supplementalGroup.articles"
						:key="subArticle.uuid"
						class="text-ellipsis article-meta supplemental"
						:class="supplementalGroup.class">
						<a
							:class="{
								active: selectedArticle.uuid === subArticle.uuid
							}"
							@click="onArticleSelect(subArticle.uuid)">
							<component :is="supplementalGroup.icon"></component>
							<div class="title-container">
								<div class="article-title">
									{{ subArticle.title }}
									<template v-if="annotations?.[subArticle.uuid]"> (Highlighted) </template>
								</div>
								<div class="sub-title">{{ supplementalGroup.subTitle }}</div>
							</div>
						</a>
					</li>
				</template>
			</ul>
		</nav>
	</div>
</template>
